/*
  ALTRA — モバイルファセットを drill-down から inline アコーディオンへ
  ==================================================================
  Rise のモバイルドロワーは各軸 <details class="mobile-facets__details"> の submenu を
  画面右からスライドインさせる drill-down(軸ごとに「← 戻る」「適用」を要し、複数軸の同時
  選択がしづらい)。本スクリプトは、軸サマリのクリックを menu-drawer(global.js)の
  onSummaryClick(bubble ハンドラ)より先に capture フェーズで掴み、伝播を止める。

  なぜ stopPropagation か:
  - onSummaryClick は軸 <details> に .menu-opening と、親 .has-submenu に .submenu-open を
    付与し submenu に trapFocus をかける(drill-down 演出)。.submenu-open は Rise の
    `.mobile-facets .submenu-open { visibility: hidden }` を発火させ、inline 展開にすると
    他の軸サマリまで不可視化してアコーディオンが破綻する。これらの副作用を根元で止める。
  - preventDefault はしない。native <details> の open/close トグルはそのまま活かし、
    CSS(component-facets-altra.css)の submenu static 化と合わせて inline 開閉にする。
  - menu-drawer 本体(ドロワーの開閉)は対象外。ドロワー開閉のサマリは別クラス
    (.mobile-facets__open-wrapper)なので本ハンドラは掴まない。
  - document 委譲なので、サーバ再描画でファセット DOM が差し替わっても
    (facets.js renderAdditionalElements → menu-drawer.bindEvents 再バインド)生存する。
*/
(function () {
  function onClickCapture(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var summary = target.closest('summary.mobile-facets__summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || !details.classList.contains('mobile-facets__details')) return;

    // menu-drawer の onSummaryClick(bubble)へ伝播させない(=drill-down 副作用を止める)。
    // native の <details> トグルは default action として継続するため open/close は効く。
    event.stopPropagation();

    // aria-expanded は menu-drawer が担っていたので、native トグル後の状態を自前で反映。
    window.requestAnimationFrame(function () {
      summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    });
  }

  document.addEventListener('click', onClickCapture, true);
})();
